import { z } from 'zod';

import { i18n } from '~/utils';

import { type Option } from '@vestigas/ui';

export const CERTIFICATE_ROLE_I18N_MAP = () => ({
  buyer: i18n.t(($) => $.users.certificateRole.buyer, { ns: 'clients' }),
  carrier: i18n.t(($) => $.users.certificateRole.carrier, { ns: 'clients' }),
  on_behalf_buyer: i18n.t(($) => $.users.certificateRole.onBehalfBuyer, {
    ns: 'clients',
  }),
  on_behalf_carrier: i18n.t(($) => $.users.certificateRole.onBehalfCarrier, {
    ns: 'clients',
  }),
  on_behalf_recipient: i18n.t(
    ($) => $.users.certificateRole.onBehalfRecipient,
    {
      ns: 'clients',
    },
  ),
  on_behalf_seller: i18n.t(($) => $.users.certificateRole.onBehalfSeller, {
    ns: 'clients',
  }),
  on_behalf_supplier: i18n.t(($) => $.users.certificateRole.onBehalfSupplier, {
    ns: 'clients',
  }),
  recipient: i18n.t(($) => $.users.certificateRole.recipient, {
    ns: 'clients',
  }),
  supplier: i18n.t(($) => $.users.certificateRole.supplier, { ns: 'clients' }),
});

export const certificateRoleEnum = z.enum(
  [
    'supplier',
    'carrier',
    'recipient',
    'buyer',
    'on_behalf_supplier',
    'on_behalf_carrier',
    'on_behalf_buyer',
    'on_behalf_recipient',
    'on_behalf_seller',
  ],
  { message: i18n.t(($) => $.users.certificateRole.error, { ns: 'clients' }) },
);

export type CertificateRole = z.infer<typeof certificateRoleEnum>;

export function getCertificateRoleOptions(): Option[] {
  return Object.entries(CERTIFICATE_ROLE_I18N_MAP()).map(([value, label]) => ({
    value,
    label,
  }));
}
